import React from 'react';
import { XS_MOBILE, SM_MOBILE, MD_TABLET } from "../../../../constants/textConstants";
import { connect } from "react-redux";
import { Card, CircleButton, Icon, Typography } from '../../index';
import './circle_button_card.scss';

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export const CircleButtonCard = connect(mapStateToProps)(({
    arrowIcon,
    body,
    cardIcon = '',
    className = '',
    disabled = false,
    href,
    to,
    onClick,
    target,
    title,
    titleStyle,
    bodyStyle,
    screenBreakPoint
}) => {

    const isMobile = ([XS_MOBILE, SM_MOBILE, MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;
    const iconColor = cardIcon?.color ? cardIcon?.color : "$color-primary-a3";
    const bodyColor = disabled ? "$color-secondary-a4" : "";
    const titleColor = disabled ? "$color-secondary-a4" : "$color-primary-a3";
    const bodyType = bodyStyle?.type ? bodyStyle?.type : "body-01";
    const titleType = titleStyle?.type ? titleStyle?.type : isMobile ? "body-03" : "heading-02";
    const titleBold = titleStyle?.bold !== undefined ? titleStyle?.bold : true;

    const circleButtonClasses = [
        `mybswh-circle-button-card`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <Card
            className={circleButtonClasses}
            disabled={disabled}
            href={href}
            target={target}
            to={to}
            onClick={onClick}
        >
            <div className="mybswh-circle-button-card__main">
                {cardIcon &&
                    <div className="mybswh-circle-button-card__icon">
                        <Icon
                            color={iconColor}
                            disabled={disabled}
                            name={cardIcon?.name || 'account'}
                            set={cardIcon?.set || "system"}
                            size="medium"
                        />
                    </div>
                }
                <div className="mybswh-circle-button-card__content">
                    <div className="mybswh-circle-button-card__title">
                        <Typography type={titleType} color={titleColor} tag="div" bold={titleBold}>{title}</Typography>
                    </div>
                    <Typography type={bodyType} color={bodyColor} tag="div">{body}</Typography>
                </div>
            </div>
            <div className="mybswh-circle-button-card__button">
                <CircleButton
                    as={'div'}
                    colorStyle={arrowIcon?.colorStyle || "accent"}
                    disabled={disabled}
                    name={arrowIcon?.name || "arrow"}
                />
            </div>
        </Card>
    )
});